module.exports = {
	"PRERENDER": [
		{
			"isSubtitle": true,
			"title": "Configure Server Cache"
		},
		{
			"name": "prerender-disable-cache",
			"descriptionHtml": "Disables/ignores the default 300 second (5 minutes) cache on the headless-render-api.com servers",
			"curlExample": "curl --header \"Prerender-Disable-Cache: true\""
		},
		{
			"name": "prerender-cache-duration",
			"descriptionHtml": "Change the default cache duration from 300s (5 minutes) to anything up to 2592000s (1 month)<br />\n(ignored if cache is disabled)",
			"curlExample": "curl --header \"Prerender-Cache-Duration: 2592000\""
		},
		{
			"name": "prerender-recache",
			"descriptionHtml": "Updates/refreshes the cache even if it already exists. It will default to 300s, so use with Prerender-Cache-Duration<br />\n(ignored if cache is disabled)",
			"curlExample": "curl --header \"Prerender-Recache: true\""
		},
		{
			"isSubtitle": true,
			"title": "Disable Injected Scripts"
		},
		{
			"name": "prerender-disable-ajax-preload",
			"descriptionHtml": "Removes a JavaScript monkeypatch from the prerendered page that preloads your intial AJAX requests\n<br /><br />\nRead more and see&nbsp;\n<a href=\"https://github.com/sanfrancesco/prerendercloud-ajaxmonkeypatch#ajax-preload\">\n  Ajax-Preload source code\n</a>",
			"curlExample": "curl --header \"Prerender-Disable-Ajax-Preload: true\""
		},
		{
			"name": "prerender-disable-ajax-bypass",
			"descriptionHtml": "Removes a JavaScript monkeypatch from the prerendered page that adds X-Prerendered to the header of all XHR and fetch requests signaling to the middleware to go straight to origin\n<br /><br />\n\nRead more and see&nbsp;\n<a href=\"https://github.com/sanfrancesco/prerendercloud-ajaxmonkeypatch#ajax-bypass\">\n  Ajax-Bypass source code\n</a>",
			"curlExample": "curl --header \"Prerender-Disable-Ajax-Bypass: true\""
		},
		{
			"name": "prerender-disable-head-dedupe",
			"descriptionHtml": "Removes a JavaScript monkeypatch from the prerendered page that is intended to prevent duplicate meta/title/script/style tags\n<br /><br /><div>\nRead more and see&nbsp;\n<a href=\"https://github.com/sanfrancesco/prerendercloud-ajaxmonkeypatch#head-dedupe\">\n  Head-Dedupe source code\n</a>\n</div><br />\n<div>\nSome libs/frameworks detect existing meta/title/style and don't need\nthis, but in our experience this is still a worthwhile default.\n</div>",
			"curlExample": "curl --header \"Prerender-Disable-Head-Dedupe: true\""
		},
		{
			"isSubtitle": true,
			"title": "Headless-Render-API Server Behavior"
		},
		{
			"name": "prerender-wait-extra-long",
			"descriptionHtml": "Waits longer than normal for a page to finish rendering. Similar to\nPuppeteer's <code>{ waitUntil: 'networkidle' }</code>. Useful for\npages that depend on AJAX/XHR that fire late or IPFS hosted pages",
			"curlExample": "curl --header \"Prerender-Wait-Extra-Long: true\""
		},
		{
			"name": "prerender-dont-wait-for-web-sockets",
			"descriptionHtml": "By default, headless-render-api.com will wait for all ws activity to\nfinish, but it doesn't make sense to \"wait\" for them to finish if they\nnever stop. An example: real time prices on a stock price website.",
			"curlExample": "curl --header \"prerender-dont-wait-for-web-sockets: true\""
		},
		{
			"name": "prerender-block-cookies",
			"descriptionHtml": "By default, headless-render-api.com sends cookies back to the server.\nUse this to block them.",
			"curlExample": "curl --header \"prerender-block-cookies: true\""
		},
		{
			"name": "origin-header-whitelist",
			"descriptionHtml": "A CSV of headers to forward. (must start with prerendercloud-) By default, the GET request headless-render-api.com makes to your origin server is clean/pure (without any remnants of the original user request). This header allows you to forward certain headers to your origin.\n<br /><br />\nUsage of this header disables the headless-browser-api server-side cache\n<br /><br />\n<a href=\"/docs/api/examples#origin-header-whitelist\">see more examples here</a>",
			"curlExampleHtml": "\ncurl --header \"origin-header-whitelist: prerendercloud-whatever,prerendercloud-b\" \\<br />\n&nbsp;&nbsp;&nbsp;&nbsp;--header \"prerendercloud-whatever: some-value \\<br />\n&nbsp;&nbsp;&nbsp;&nbsp;--header \"prerendercloud-b: some-other-value\""
		},
		{
			"name": "prerender-meta-only",
			"descriptionHtml": "This option tells headless-render-api.com to only pre-render the &lt;title&gt; and &lt;meta&gt; tags in the &lt;meta&gt; section. The returned HTML payload will otherwise be unmodified.",
			"curlExample": "curl --header \"Prerender-Meta-Only: true\""
		},
		{
			"name": "prerender-remove-script-tags",
			"descriptionHtml": "Removes all script tags except for application/ld+json. If you're pre-rendering, this means no client-side JavaScript and thus your app will no longer be isomorphic. Useful for reducing byte payload for the crawling/scraping use case.",
			"curlExample": "curl --header \"prerender-remove-script-tags: true\""
		},
		{
			"name": "prerender-remove-trailing-slash",
			"descriptionHtml": "Removes trailing slash from URLs submitted to the API. e.g. example.com/docs/ -> example.com/docs. Originally intended for the pre-rendering use case, the primary purpose is to achieve a higher server cache hit rate. The SEO best practice is to use to 301s to redirect trailing slashes to non trailing slashes before service.headless-render-api.com is hit and/or using link rel canonical tag.",
			"curlExample": "curl --header \"prerender-remove-trailing-slash: true\""
		},
		{
			"name": "prerender-follow-redirects",
			"descriptionHtml": "By default, if your origin server returns 301/302, headless-render-api.com will just return that outright - which is appropriate for the common use case of proxying traffic through headless-render-api.com. If using the API in a crawling/scraping/batching you may want to follow redirects.",
			"curlExample": "curl --header \"Prerender-Follow-Redirects: true\""
		},
		{
			"isSubtitle": true,
			"title": "Device Metrics"
		},
		{
			"name": "prerender-device-width",
			"descriptionHtml": "Overrides device screen width (default: 1366)",
			"curlExample": "curl --header \"prerender-device-width: 800\""
		},
		{
			"name": "prerender-device-height",
			"descriptionHtml": "Overrides device screen height (default: 768)",
			"curlExample": "curl --header \"prerender-device-height: 600\""
		},
		{
			"name": "prerender-device-is-mobile",
			"descriptionHtml": "Whether to emulate mobile device (default: false).\n<br /><br />\nThis includes viewport meta tag, overlay scrollbars, text autosizing and more. In other words, whether the meta viewport tag is taken into account.\n<br /><br />\nan example of \"viewport meta tag\": <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />",
			"curlExample": "curl --header \"prerender-device-is-mobile: true\""
		},
		{
			"isSubtitle": true,
			"title": "Configure Server Response"
		},
		{
			"name": "prerender-with-screenshot",
			"descriptionHtml": "Changes the response from text/html to application/json and returns an object 2 fields: {body, screenshot}\n<br />\n<div>\n  The values are base64 encoded:\n  <ul>\n    <li>body is the normal pre-rendered response</li>\n    <li>screenshot is a base64 encoded PNG</li>\n  </ul>\n  <p>\n    This is useful for savings screenshots or injecting them as open graph\n    images. Often used with <code>Prerender-With-Metadata</code>\n  </p>\n</div>",
			"curlExample": "curl --header \"Prerender-With-Screenshot: true\""
		},
		{
			"name": "prerender-with-metadata",
			"descriptionHtml": "Changes the response from text/html to application/json and returns an object 3 fields: {body, meta, links}\n<br />\n<div>\n  The values are base64 encoded:\n  <ul>\n    <li>body is the normal pre-rendered response</li>\n    <li>\n      meta is an object that includes&nbsp;\n      { title, metaDescription, h1, ogImage, ogTitle, twitterCard }\n    </li>\n    <li>links is an array of URLs/paths on the page</li>\n  </ul>\n  <p>\n    This is useful for capturing SEO-relevant metadata during the\n    pre-render.\n  </p>\n</div>",
			"curlExample": "curl --header \"Prerender-With-Metadata: true\""
		}
	],
	"SCREENSHOT": [
		{
			"isSubtitle": true,
			"title": "Device Metrics"
		},
		{
			"name": "prerender-device-width",
			"descriptionHtml": "Overrides device screen width (default: 1366)",
			"curlExample": "curl --header \"prerender-device-width: 800\""
		},
		{
			"name": "prerender-device-height",
			"descriptionHtml": "Overrides device screen height (default: 768)",
			"curlExample": "curl --header \"prerender-device-height: 600\""
		},
		{
			"name": "prerender-device-is-mobile",
			"descriptionHtml": "Whether to emulate mobile device (default: false).\n<br /><br />\nThis includes viewport meta tag, overlay scrollbars, text autosizing and more. In other words, whether the meta viewport tag is taken into account.\n<br /><br />\nan example of \"viewport meta tag\": <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />",
			"curlExample": "curl --header \"prerender-device-is-mobile: true\""
		},
		{
			"isSubtitle": true,
			"title": "Screenshots"
		},
		{
			"name": "prerender-viewport-query-selector",
			"descriptionHtml": "Specify a DOM element on the page to take a screenshot of, as opposed to\nthe default of the entire window",
			"curlExample": "curl --header \"Prerender-Viewport-Query-Selector: #open-graph-div\""
		},
		{
			"name": "prerender-viewport-query-selector-padding",
			"descriptionHtml": "Use with query-selector option to add padding around the DOM element",
			"curlExample": "curl --header \"prerender-viewport-query-selector-padding: 10\""
		},
		{
			"name": "prerender-viewport-width",
			"descriptionHtml": "Width of viewport (screenshots only, not compatible with query selector)",
			"curlExample": "curl --header \"prerender-viewport-width: 100\""
		},
		{
			"name": "prerender-viewport-height",
			"descriptionHtml": "Height of viewport (screenshots only, not compatible with query selector)",
			"curlExample": "curl --header \"prerender-viewport-height: 100\""
		},
		{
			"name": "prerender-viewport-x",
			"descriptionHtml": "Viewport X offset in pixels (screenshots only, not compatible with query selector)",
			"curlExample": "curl --header \"prerender-viewport-x: 0\""
		},
		{
			"name": "prerender-viewport-y",
			"descriptionHtml": "Viewport Y offset in pixels (screenshots only, not compatible with query selector)",
			"curlExample": "curl --header \"prerender-viewport-y: 0\""
		},
		{
			"name": "prerender-viewport-scale",
			"descriptionHtml": "Page scale factor. Default: 1, min: 0.1, max: 3.0",
			"curlExample": "curl --header \"prerender-viewport-scale: 1.5\""
		},
		{
			"name": "prerender-screenshot-format",
			"descriptionHtml": "Default is png, choose from: jpeg, png, webp",
			"curlExample": "curl --header \"prerender-screenshot-format: webp\""
		},
		{
			"isSubtitle": true,
			"title": "Browser Emulated Media"
		},
		{
			"name": "prerender-emulated-media",
			"descriptionHtml": "Emulates the given media type or media feature for CSS media queries\n<br /><br />\ndefault: screen\n<br />\n<br />\nPossible values are: screen, print, braille, embossed, handheld,\nprojection, speech, tty, tv",
			"curlExample": "curl --header \"Prerender-Emulated-Media: screen\""
		},
		{
			"isSubtitle": true,
			"title": "Headless-Render-API Server Behavior"
		},
		{
			"name": "prerender-wait-extra-long",
			"descriptionHtml": "Waits longer than normal for a page to finish rendering. Similar to\nPuppeteer's <code>{ waitUntil: 'networkidle' }</code>. Useful for\npages that depend on AJAX/XHR that fire late or IPFS hosted pages",
			"curlExample": "curl --header \"Prerender-Wait-Extra-Long: true\""
		},
		{
			"name": "prerender-dont-wait-for-web-sockets",
			"descriptionHtml": "By default, headless-render-api.com will wait for all ws activity to\nfinish, but it doesn't make sense to \"wait\" for them to finish if they\nnever stop. An example: real time prices on a stock price website.",
			"curlExample": "curl --header \"prerender-dont-wait-for-web-sockets: true\""
		},
		{
			"name": "prerender-block-cookies",
			"descriptionHtml": "By default, headless-render-api.com sends cookies back to the server.\nUse this to block them.",
			"curlExample": "curl --header \"prerender-block-cookies: true\""
		}
	],
	"PDF": [
		{
			"isSubtitle": true,
			"title": "PDFs"
		},
		{
			"name": "prerender-pdf-no-page-breaks",
			"descriptionHtml": "Attempts to remove all page breaks (only for PDF)\n<br />\nAlternatively, use \"@page\" in CSS for complete control\n<code>@page {size: 8.5in 11in;}</code>\n<br /><br />\n<br /><br />\nUse of this \"no-page-breaks\" option overwrites these other options:\n<br />\nprerender-pdf-page-ranges=1\n<br />\nprerender-pdf-prefer-css-page-size=true\n<br />\nand ignores prerender-pdf-margin-* options",
			"curlExample": "curl --header \"prerender-pdf-no-page-breaks: true\""
		},
		{
			"name": "prerender-pdf-page-ranges",
			"descriptionHtml": "Paper ranges to print, one based, e.g., '1-5, 8, 11-13'. Pages are printed in the document order, not in the order specified, and no more than once. Defaults to empty string, which implies the entire document is printed. The page numbers are quietly capped to actual page count of the document, and ranges beyond the end of the document are ignored. If this results in no pages to print, an error is reported. It is an error to specify a range with start greater than end.",
			"curlExample": "curl --header \"prerender-pdf-page-ranges: 1-3, 5, 7, 10-15\""
		},
		{
			"name": "prerender-pdf-scale",
			"descriptionHtml": "Scale of the webpage rendering. Defaults to 1. Min: 0.1, max: 2",
			"curlExample": "curl --header \"prerender-pdf-scale: 1\""
		},
		{
			"name": "prerender-pdf-prefer-css-page-size",
			"descriptionHtml": "Whether or not to prefer page size as defined by css. Defaults to false, in which case the content will be scaled to fit the paper size.\n<br /><br />\nUse of prerender-pdf-no-page-breaks forces this option to true",
			"curlExample": "curl --header \"prerender-pdf-prefer-css-page: true\""
		},
		{
			"name": "prerender-pdf-print-background",
			"descriptionHtml": "Print background graphics. Defaults to false",
			"curlExample": "curl --header \"prerender-pdf-print-background: true\""
		},
		{
			"name": "prerender-pdf-landscape",
			"descriptionHtml": "Whether to render the PDF in landscape mode (Paper orientation). Defaults to false.",
			"curlExample": "curl --header \"prerender-pdf-landscape: true\""
		},
		{
			"name": "prerender-pdf-margin-top",
			"descriptionHtml": "Top margin in inches. Defaults to 1cm (~0.4 inches).\n<br />\nIgnored if using prerender-pdf-no-page-breaks or prerender-pdf-prefer-css-page-size",
			"curlExample": "curl --header \"prerender-pdf-margin-top: 0.4\""
		},
		{
			"name": "prerender-pdf-margin-right",
			"descriptionHtml": "Right margin in inches. Defaults to 1cm (~0.4 inches).",
			"curlExample": "curl --header \"prerender-pdf-margin-right: 0.4\""
		},
		{
			"name": "prerender-pdf-margin-bottom",
			"descriptionHtml": "Bottom margin in inches. Defaults to 1cm (~0.4 inches).",
			"curlExample": "curl --header \"prerender-pdf-margin-bottom: 0.4\""
		},
		{
			"name": "prerender-pdf-margin-left",
			"descriptionHtml": "Left margin in inches. Defaults to 1cm (~0.4 inches).",
			"curlExample": "curl --header \"prerender-pdf-margin-left: 0.4\""
		},
		{
			"name": "prerender-pdf-paper-width",
			"descriptionHtml": "Paper width in inches. Defaults to 8.5 inches",
			"curlExample": "curl --header \"prerender-pdf-paper-width: 8.5\""
		},
		{
			"name": "prerender-pdf-paper-height",
			"descriptionHtml": "Paper height in inches. Defaults to 11 inches.",
			"curlExample": "curl --header \"prerender-pdf-paper-height: 11\""
		},
		{
			"isSubtitle": true,
			"title": "Browser Emulated Media"
		},
		{
			"name": "prerender-emulated-media",
			"descriptionHtml": "Emulates the given media type or media feature for CSS media queries\n<br /><br />\ndefault: screen\n<br />\n<br />\nPossible values are: screen, print, braille, embossed, handheld,\nprojection, speech, tty, tv",
			"curlExample": "curl --header \"Prerender-Emulated-Media: screen\""
		},
		{
			"isSubtitle": true,
			"title": "Headless-Render-API Server Behavior"
		},
		{
			"name": "prerender-wait-extra-long",
			"descriptionHtml": "Waits longer than normal for a page to finish rendering. Similar to\nPuppeteer's <code>{ waitUntil: 'networkidle' }</code>. Useful for\npages that depend on AJAX/XHR that fire late or IPFS hosted pages",
			"curlExample": "curl --header \"Prerender-Wait-Extra-Long: true\""
		},
		{
			"name": "prerender-dont-wait-for-web-sockets",
			"descriptionHtml": "By default, headless-render-api.com will wait for all ws activity to\nfinish, but it doesn't make sense to \"wait\" for them to finish if they\nnever stop. An example: real time prices on a stock price website.",
			"curlExample": "curl --header \"prerender-dont-wait-for-web-sockets: true\""
		},
		{
			"name": "prerender-block-cookies",
			"descriptionHtml": "By default, headless-render-api.com sends cookies back to the server.\nUse this to block them.",
			"curlExample": "curl --header \"prerender-block-cookies: true\""
		}
	],
	"SCRAPE": [
		{
			"isSubtitle": true,
			"title": "Headless-Render-API Server Behavior"
		},
		{
			"name": "prerender-wait-extra-long",
			"descriptionHtml": "Waits longer than normal for a page to finish rendering. Similar to\nPuppeteer's <code>{ waitUntil: 'networkidle' }</code>. Useful for\npages that depend on AJAX/XHR that fire late or IPFS hosted pages",
			"curlExample": "curl --header \"Prerender-Wait-Extra-Long: true\""
		},
		{
			"name": "prerender-dont-wait-for-web-sockets",
			"descriptionHtml": "By default, headless-render-api.com will wait for all ws activity to\nfinish, but it doesn't make sense to \"wait\" for them to finish if they\nnever stop. An example: real time prices on a stock price website.",
			"curlExample": "curl --header \"prerender-dont-wait-for-web-sockets: true\""
		},
		{
			"name": "prerender-block-cookies",
			"descriptionHtml": "By default, headless-render-api.com sends cookies back to the server.\nUse this to block them.",
			"curlExample": "curl --header \"prerender-block-cookies: true\""
		},
		{
			"name": "prerender-follow-redirects",
			"descriptionHtml": "By default, if your origin server returns 301/302, headless-render-api.com will just return that outright - which is appropriate for the common use case of proxying traffic through headless-render-api.com. If using the API in a crawling/scraping/batching you may want to follow redirects.",
			"curlExample": "curl --header \"Prerender-Follow-Redirects: true\""
		},
		{
			"isSubtitle": true,
			"title": "Device Metrics"
		},
		{
			"name": "prerender-device-width",
			"descriptionHtml": "Overrides device screen width (default: 1366)",
			"curlExample": "curl --header \"prerender-device-width: 800\""
		},
		{
			"name": "prerender-device-height",
			"descriptionHtml": "Overrides device screen height (default: 768)",
			"curlExample": "curl --header \"prerender-device-height: 600\""
		},
		{
			"name": "prerender-device-is-mobile",
			"descriptionHtml": "Whether to emulate mobile device (default: false).\n<br /><br />\nThis includes viewport meta tag, overlay scrollbars, text autosizing and more. In other words, whether the meta viewport tag is taken into account.\n<br /><br />\nan example of \"viewport meta tag\": <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />",
			"curlExample": "curl --header \"prerender-device-is-mobile: true\""
		},
		{
			"isSubtitle": true,
			"title": "Browser Emulated Media"
		},
		{
			"name": "prerender-emulated-media",
			"descriptionHtml": "Emulates the given media type or media feature for CSS media queries\n<br /><br />\ndefault: screen\n<br />\n<br />\nPossible values are: screen, print, braille, embossed, handheld,\nprojection, speech, tty, tv",
			"curlExample": "curl --header \"Prerender-Emulated-Media: screen\""
		},
		{
			"isSubtitle": true,
			"title": "Configure Server Response"
		},
		{
			"name": "prerender-with-screenshot",
			"descriptionHtml": "Changes the response from text/html to application/json and returns an object 2 fields: {body, screenshot}\n<br />\n<div>\n  The values are base64 encoded:\n  <ul>\n    <li>body is the normal pre-rendered response</li>\n    <li>screenshot is a base64 encoded PNG</li>\n  </ul>\n  <p>\n    This is useful for savings screenshots or injecting them as open graph\n    images. Often used with <code>Prerender-With-Metadata</code>\n  </p>\n</div>",
			"curlExample": "curl --header \"Prerender-With-Screenshot: true\""
		},
		{
			"name": "prerender-with-metadata",
			"descriptionHtml": "Changes the response from text/html to application/json and returns an object 3 fields: {body, meta, links}\n<br />\n<div>\n  The values are base64 encoded:\n  <ul>\n    <li>body is the normal pre-rendered response</li>\n    <li>\n      meta is an object that includes&nbsp;\n      { title, metaDescription, h1, ogImage, ogTitle, twitterCard }\n    </li>\n    <li>links is an array of URLs/paths on the page</li>\n  </ul>\n  <p>\n    This is useful for capturing SEO-relevant metadata during the\n    pre-render.\n  </p>\n</div>",
			"curlExample": "curl --header \"Prerender-With-Metadata: true\""
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/api-options.json
// module id = 734
// module chunks = 5 6 7 8 9